export enum ProgressStatus {
  Unlearned = 'Unlearned',
  Learning = 'Learning',
  Testing = 'Testing',
  Learned = 'Learned',
  Exemption = 'Exemption',
}
